import Alpine from "@alpinejs/csp";

// Animated stat counter — counts from 0 to target on viewport entry
Alpine.data('statCounter', function () {
    var target = 0;
    var useCommas = false;
    var staggerMs = 0;
    var timerId = null;
    var rafId = null;

    return {
        displayNum: '',
        done: false,

        init: function () {
            target = parseInt(this.$el.dataset.target, 10) || 0;
            useCommas = this.$el.dataset.commas === '1';
            staggerMs = parseInt(this.$el.dataset.stagger, 10) || 0;

            if (target === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                this.displayNum = useCommas ? target.toLocaleString('en-US') : String(target);
                this.done = true;
                return;
            }

            this.displayNum = '0';
        },

        animate: function () {
            if (this.done) return;
            this.done = true;

            var self = this;
            var duration = 1500;

            timerId = setTimeout(function () {
                var start = performance.now();
                function tick(now) {
                    var elapsed = now - start;
                    var progress = Math.min(elapsed / duration, 1);
                    var eased = 1 - Math.pow(1 - progress, 3);
                    var current = Math.round(eased * target);
                    self.displayNum = useCommas ? current.toLocaleString('en-US') : String(current);
                    if (progress < 1) {
                        rafId = requestAnimationFrame(tick);
                    }
                }
                rafId = requestAnimationFrame(tick);
            }, staggerMs);
        },

        destroy: function () {
            if (timerId) clearTimeout(timerId);
            if (rafId) cancelAnimationFrame(rafId);
        }
    };
});
